import React from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import EasyTooltip from 'components/EasyTooltip';
import BadgeImage from 'components/BadgeImage';
import { jsx as _jsx } from "react/jsx-runtime";
function UserBadgeImage(_ref) {
  var badge = _ref.badge,
    hasUserBadge = _ref.hasUserBadge,
    size = _ref.size;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var tooltipId = useUniqueId();
  var altText = hasUserBadge ? badge.imageAlternativeText : t('property_greyed_out', {
    content: badge.imageAlternativeText
  });
  return /*#__PURE__*/_jsx(EasyTooltip, {
    renderWhenClosed: true,
    id: tooltipId,
    content: t(hasUserBadge ? 'badge_unlocked_tooltip' : 'badge_locked_tooltip'),
    children: /*#__PURE__*/_jsx(BadgeImage, {
      src: badge.pictureUrl,
      alt: altText,
      variant: badge.style,
      dimmed: !hasUserBadge,
      size: size,
      "aria-describedby": tooltipId,
      tabIndex: 0
    })
  });
}
export default UserBadgeImage;